import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function NcertBookBioTopics() {
  return (
    <>

      <AllSubjectTopics subject="biology" type="ncertbook" />

    </>
  );
}

export default NcertBookBioTopics;